module.exports = __webpack_public_path__ + "static/img/shcygn2.916b362.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newestqianniu/shcygn2.png
// module id = 372
// module chunks = 0